// GENERATED CODE - DO NOT EDIT
// These enums are ordered by priority in terms of what should be shown to the
// patient as the reason for the date restriction.
// Any new restriction reason should be added based on priority.
export const DateRestrictionReasonMap = {
    // We may never deliver deliveries outside of our service zone.
    OUT_OF_ZONE: 'out_of_zone',
    // We can't yet bill insurance for this delivery.
    REFILL_TOO_SOON: 'refill_too_soon',
    // Another delivery is already scheduled for this medication; the next delivery
    // should be scheduled after the upcoming one.
    DELIVERY_UPCOMING: 'delivery_upcoming',
    // We recently delivered this medication; a certain amount of time must pass before
    // we deliver it again.
    DELIVERED_RECENTLY: 'delivered_recently',
    // The prescription is unable to be filled prior to this date either to the prescribed
    // earliest fill date or the control review status.
    EARLIEST_FILL_DATE: 'earliest_fill_date',
    // The medication is subject to some lead time for preparing the prescribed compound.
    COMPOUND: 'compound',
    // The intention here is to ensure there's no more than a day
    // between when we ship the refrigerated med and when it will be received
    REFRIGERATED_ARRIVING_AFTER_UNDELIVERABLE: 'refrigerated_arriving_after_undeliverable',
    // A refrigerated medication should not arrive the day after a holiday
    REFRIGERATED_ARRIVING_AFTER_HOLIDAY: 'refrigerated_arriving_after_holiday',
    // Some transit time is required for this mail delivery.
    MAIL_DELIVERY_METHOD: 'mail',
    // The prescription is out of stock due the facility reaching its C2 ordering limit.
    OUT_OF_STOCK_C_2__LIMIT: 'out_of_stock_c2_limit',
    // The prescription is out of stock due to the long term manufacturing delays.
    OUT_OF_STOCK_LONGTERM_BACKORDER: 'out_of_stock_longterm_backorder',
    // The prescription is out of stock due to the short term manufacturing delays.
    OUT_OF_STOCK_VENDOR: 'out_of_stock_vendor',
    // The prescription is out of stock due the fact that the product is no longer being produced.
    OUT_OF_STOCK_OBSOLETE: 'out_of_stock_obsolete',
    // The prescription is out of stock until this date.
    OUT_OF_STOCK: 'oos',
    // It is too late to ship this medication today.
    PAST_CUTOFF: 'past_cutoff',
    // There is a delivery window closure
    DELIVERY_WINDOW_CAPACITY_CLOSURE: 'delivery_window_capacity_closure',
    // Alto is closed for business on this day.
    HOLIDAY: 'holiday',
    // The medication is available for same day delivery.
    AVAILABLE: 'available',
    // The delivery facility is closed for an emergency
    EMERGENCY_CLOSURE: 'emergency_closure',
    // Ship-by dates on weekends are not acceptable in this context (e.g. rolling a delivery).
    WEEKEND_UNAVAILABLE: 'weekend_unavailable',
    // The compound pharmacy that makes this medication is not open.
    COMPOUNDER_NOT_OPEN: 'compounder_not_open',
    // The delivery is billed to a Progyny authorization, and the authorization has an end date after which the delivery
    // cannot be delivered.
    PROGYNY_AUTHORIZATION_EXPIRATION: 'progyny_authorization_expiration',
};
//# sourceMappingURL=date_restriction_reason.js.map